import React, { useMemo, useState } from 'react';
import { useCurrentWorkspace } from '@hooks/workspace';
import type { OnboardingStepsType } from '@context/OnboardingProcessProvider';
import WatchVideoModal from '@components/Modals/BootcampModal/components/WatchVideoModal/WatchVideoModal';

// import CreateCampaign from '@assets/videos/create-campaign.png';
// import CreateTaskFromComment from '@assets/videos/create-task-from-comment.png';
// import CreateTask from '@assets/videos/create-task.png';
// import UploadAsset from '@assets/videos/upload-asset.png';
import RouteForApproval from '@assets/videos/route-for-approval.png';

import './TabVideo.less';

type ItemType = {
  type: OnboardingStepsType;
  title: string;
  time: string;
  image: string;
};

export default function TabVideo() {
  const [currentWorkspace] = useCurrentWorkspace(true);
  const isContributor = currentWorkspace.role === 'workspace://contributor';

  const [watchVideoModalOpen, setWatchVideoModalOpen] = useState<
    OnboardingStepsType | false
  >(false);

  const items: ItemType[] = useMemo(() => {
    // if (isContributor) {
    //   return [
    //     {
    //       type: 'upload-asset',
    //       title: 'Upload media',
    //       time: '54 sec',
    //       image: UploadAsset
    //     },
    //     {
    //       type: 'review-asset',
    //       title: 'Review media',
    //       time: '2 min 54 sec',
    //       image: CreateTaskFromComment
    //     },
    //     {
    //       type: 'create-task-from-comment',
    //       title: 'Turn feedback into tasks',
    //       time: '1 min 46 sec',
    //       image: CreateTask
    //     }
    //   ];
    // }
    // return [
    //   {
    //     type: 'create-campaign',
    //     title: 'Create your first project',
    //     time: '1 min 2 sec',
    //     image: CreateCampaign
    //   },
    //   {
    //     type: 'upload-asset',
    //     title: 'Upload media',
    //     time: '54 sec',
    //     image: UploadAsset
    //   },
    //   {
    //     type: 'route-for-approval',
    //     title: 'Route for approval',
    //     time: '1 min 53 sec',
    //     image: RouteForApproval
    //   },
    //   {
    //     type: 'review-asset',
    //     title: 'Review media',
    //     time: '2 min 54 sec',
    //     image: CreateTaskFromComment
    //   },
    //   {
    //     type: 'create-task-from-comment',
    //     title: 'Turn feedback into tasks',
    //     time: '1 min 46 sec',
    //     image: CreateTask
    //   },
    // {
    //   type: 'create-task-from-comment',
    //   title: 'Integrate with your creative stack',
    //   time: '1 min 46 sec',
    //   image: CreateTask
    // }
    // ];

    return [
      {
        type: 'route-for-approval',
        title: 'Route for approval',
        time: '3 min 17 sec',
        image: RouteForApproval
      }
    ];
  }, [isContributor]);

  return (
    <div>
      <div className="bootcamp-modal_tabs-label">Streamwork Bootcamp</div>
      <div className="bootcamp-modal_tabs-title">Video Tutorials</div>
      <div className="bootcamp-modal_tabs-text">
        Short how-to videos to get you up to speed fast.
      </div>
      <div className="bootcamp-tab-video_content">
        {items.map((item) => (
          <div
            key={item.type}
            onClick={() => setWatchVideoModalOpen(item.type)}
            className="bootcamp-tab-video_block"
          >
            <div className="bootcamp-tab-video_block-image">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="bootcamp-tab-video_block-info">
              <div className="bootcamp-tab-video_block-info-text">Video</div>
              <div className="bootcamp-tab-video_block-info-text">
                {item.time}
              </div>
            </div>
            <div className="bootcamp-tab-video_block-title">{item.title}</div>
          </div>
        ))}
      </div>
      <WatchVideoModal
        visible={watchVideoModalOpen}
        setVisible={setWatchVideoModalOpen}
      />
    </div>
  );
}
